export enum SuffixEnum {
  JR = 'Jr',
  SR = 'Sr',
  I = 'I',
  II = 'II',
  III = 'III',
}

export const suffixOptions: { value: string }[] = Object.values(SuffixEnum).map(
  (value) => ({
    value,
    key: value,
  })
);
